import angular from 'angular';
/*
Directive to synchronize fields that are pre filled by browser,

Credits to
https://stackoverflow.com/questions/14965968/angularjs-browser-autofill-workaround-by-using-a-directive
*/
export const AutofillSync = ($timeout) => {
  'ngInject'
  return {
    require: 'ngModel',
      restrict: 'A',
      link ($scope, elem, attrs, ngModel) {
          var origVal = elem.val();
          var newVal;
          $timeout(function () {
              newVal = elem.val();
              if(/*ngModel.$pristine &&*/ origVal !== newVal) {
                  ngModel.$setViewValue(newVal);
              }
          }, 500);

          elem.on('$destroy', () => {
              origVal = null;
              newVal = null;
          });
      }
  };
};


// WEBPACK FOOTER //
// ./src/app/directives/autofill-sync.directive.js